import { useEffect, useState } from 'react';
import { STAGE_HEIGHT, STAGE_WIDTH } from '../theme';
const computeScale = () => Math.min(window.innerWidth / STAGE_WIDTH, window.innerHeight / STAGE_HEIGHT);
export const useStageScale = () => {
    const [scale, setScale] = useState(computeScale);
    useEffect(() => {
        const onResize = () => setScale(computeScale());
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
    return scale;
};
